import React from 'react';
import { useNewUI } from 'hooks/useNewUI';
import styles from './UploadBlockerPopup.module.css';
import { useUploadBlocker, UPLOAD_BLOCKER_FEATURES } from './uploadBlockerShared';
import UploadBlockerPopupV2 from './UploadBlockerPopupV2';
import artImage from '../../Assets/frnds.png';

// Upload-blocker / upgrade popup shown when a free (no-plan) user tries to add
// content. A thin router: new-UI accounts get the v2 look, everyone else the
// classic split-card below. Behaviour is shared via useUploadBlocker.
function UploadBlockerPopup({ isVisible, onHide, variant = 'default' }) {
  const { enabled: isNewUI } = useNewUI();
  if (!isVisible) return null;
  if (isNewUI) return <UploadBlockerPopupV2 onHide={onHide} variant={variant} />;
  return <UploadBlockerPopupClassic onHide={onHide} variant={variant} />;
}

function UploadBlockerPopupClassic({ onHide, variant = 'default' }) {
  const { priceText, goToPlans, copy } = useUploadBlocker(onHide, variant);

  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <button type="button" className={styles.close} onClick={onHide} aria-label="Close">
          &times;
        </button>

        <div
          className={styles.art}
          style={{
            backgroundImage: `linear-gradient(150deg, rgba(90,165,239,0.92), rgba(123,97,255,0.92)), url(${artImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <span className={styles.artBadge}>{copy.badge}</span>
          <h3 className={styles.artTitle}>
            Your very own
            <br />
            streaming app
          </h3>
          <p className={styles.artSub}>
            Keep every memory in one place — upload, stream and share without limits.
          </p>
        </div>

        <div className={styles.body}>
          <p className={styles.eyebrow}>{copy.eyebrow}</p>
          <h2 className={styles.title}>{copy.title}</h2>
          <p className={styles.subtitle}>
            {copy.subtitle}
          </p>

          {copy.showPrice && priceText && (
            <div className={styles.price}>
              <span className={styles.priceValue}>{priceText}</span>
              <span className={styles.pricePer}>/ year after trial</span>
            </div>
          )}

          <ul className={styles.features}>
            {UPLOAD_BLOCKER_FEATURES.map((f) => (
              <li key={f} className={styles.feature}>
                <span className={styles.featureIcon}>✓</span>
                {f}
              </li>
            ))}
          </ul>

          <div className={styles.actions}>
            <button type="button" className={styles.primaryBtn} onClick={goToPlans}>
              {copy.primaryCta}
            </button>
            <button type="button" className={styles.secondaryBtn} onClick={onHide}>
              {copy.secondaryCta}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UploadBlockerPopup;
